import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_4";
import BlockPrincipal from "../components/block/Block_6";
import BlockSecondary from "../components/block/Block_3";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={rpdata?.gallery?.lenght > 0 ? rpdata?.gallery?.[0] : rpdata?.stock?.[0]}
        />
        <BlockPrincipal
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image1={rpdata?.gallery?.lenght > 1 ? rpdata?.gallery?.[1] : rpdata?.stock?.[1]}
          image2={rpdata?.gallery?.lenght > 2 ? rpdata?.gallery?.[2] : rpdata?.stock?.[2]}
          image3={rpdata?.gallery?.lenght > 3 ? rpdata?.gallery?.[3] : rpdata?.stock?.[3]}
          image4={rpdata?.gallery?.lenght > 4 ? rpdata?.gallery?.[4] : rpdata?.stock?.[4]}
          corte={rpdata?.gallery}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.gallery?.lenght > 5 ? rpdata?.gallery?.[5] : rpdata?.stock?.[5]}
          image1={rpdata?.gallery?.lenght > 6 ? rpdata?.gallery?.[6] : rpdata?.stock?.[6]}
          image2={rpdata?.gallery?.lenght > 7 ? rpdata?.gallery?.[7] : rpdata?.stock?.[7]}
        />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[8]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.lenght > 8 ? rpdata?.gallery?.[8] : rpdata?.stock?.[8]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
